/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from '@angular/core';
import {Router} from "@angular/router";

import {AuthenticationService} from "./authentication.service";
import {BaseService} from "./base-service";
import { RestService } from "./rest-service";
import { Url_Base } from 'app/rest-constants';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PasswordResetService extends BaseService {
  
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private mRestService: RestService,
    private http: HttpClient
  ) {
    super(router, authenticationService);
  }
  
  private getUrl(): string {
    return `${Url_Base}/password-reset/`;
  }
  
  
  sendPasswordResetEmail(emailAddress: string): Promise<void> {
    const url = this.getUrl();
    
    const body = new PasswordResetRequest();
    body.email_address = emailAddress;
    return this.http.post<void>(url, body).toPromise();
  }
  

}

class PasswordResetRequest {
  email_address: string;
}
